/* eslint-disable camelcase */
/**
 * @fileoverview GET handler for the "/engagement/segment_data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementSegmentData } from "./constants";
import type { EngagementSegmentDataResult } from "./types";

export const getEngagementSegmentData = reactQueryFetcherAdapter(
  engagementSegmentData,
  (
    signal: AbortSignal,
    segment_id: string,
    app_group_id: string,
    for_editing: boolean,
    only_get_contained_filter: boolean
  ): Promise<EngagementSegmentDataResult> => {
    return fetch(
      "/engagement/segment_data",
      "GET",
      { segment_id, app_group_id, for_editing, only_get_contained_filter },
      { signal }
    );
  }
);
